import classNames from 'classnames'
import styles from './styles.module.scss'

export const ProgramDetailsDisclaimer = props => {
  const { data, wrapperClassName, innerWrapperClassName } = props
  return (
    <section
      className={classNames(styles.programDetailsDisclaimer, wrapperClassName)}
    >
      <div className="container">
        {data?.disclaimer ? (
          <p
            className={classNames(
              styles.disclaimer,
              'bg-blue-gradient',
              innerWrapperClassName
            )}
          >
            {data?.disclaimer}
          </p>
        ) : null}
      </div>
    </section>
  )
}
